import React from "react";
import { HomeOrderBySelectTemplate } from "themes/application/home/components";

function HomeOrderBySelect(props) {
    return <HomeOrderBySelectTemplate {...props} />;
}

export default HomeOrderBySelect;
